import React from "react";
import Table from "../../ui-components/table/table";
import { getActivityLogColumns } from "./activityHistoryColumns";
import { useSelector } from "react-redux";
import { linehaulMileageSelector } from "../../slices/linehaul-mileage/linehaulMileageSlice";

export const LinehaulTripActivityContent: React.FC = () => {
  const linehaulMileageState = useSelector(linehaulMileageSelector);

  return (
    <Table
      infiniteScroll
      columns={getActivityLogColumns()}
      data={linehaulMileageState.activity}
      isLoading={linehaulMileageState.loadingActivity}
      rowHeight={120}
    />
  );
};
